export interface ArenaAnswerPayload {
  questionId: string;
  selectedAnswer: string | null;
  timeTakenMs?: number;
}

/**
 * Body for POST /arena/complete: the picked option per AI question, null for
 * a question the candidate never answered (timed out). Correctness is decided
 * server-side against the answer key stored on the arena session.
 */
export function buildArenaAnswersPayload(
  questions: ReadonlyArray<{ id: string }>,
  answers: Readonly<Record<string, string | undefined>>,
  timings: Readonly<Record<string, { timeTakenMs?: number } | undefined>>,
): ArenaAnswerPayload[] {
  return questions.map(q => {
    const picked = answers[q.id];
    return {
      questionId: q.id,
      selectedAnswer: picked && picked.trim() ? picked : null,
      timeTakenMs: timings[q.id]?.timeTakenMs,
    };
  });
}
